




























































































































































































































































































































































































































































































































































































import { getLotsPrescriber, getProgramPrescriber, postCommentProgram, deleteImageProgramPrescriber } from '@/api/api';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import { Component, Vue, Watch , Prop } from 'vue-property-decorator';
import AuthModule from '@/store/AuthModule';

import Program from '@/models/Program';
import moment from 'moment';
import get from 'lodash/get';
import { Route } from 'vue-router';
import { BACKEND_URL, IMAGES_BASE_URL } from '@/helpers/constants';
import CarouselPrescriber from '@/components/prescriber/CarouselPrescriber.vue';
import ProgramDocuments from '@/components/prescriber/ProgramDocuments.vue';
import ProgramInfosPrescriber from '@/components/prescriber/ProgramInfosPrescriber.vue';
import ProgramReportModal from '@/components/prescriber/ProgramReportModal.vue';
import concat from 'lodash/concat';
import compact from 'lodash/compact';
import ProgramLots from '@/components/prescriber/ProgramLots.vue';
import ProgramLotsCard from '@/components/prescriber/ProgramLotsCard.vue'; 
import Address from '@/models/Address';
import HonoModal from '@/components/prescriber/HonoModal.vue';
import { fetchPromotors } from '@/utils/filters';

import FiltersModule from '@/store/FiltersModule';




import GoogleMap from '../tools/GoogleMap.vue';
let program: Program | null = null;

// POI affichés par défaut à l'ouverture de la page : Transport (Bus/Tramway/Métro)
// et Restauration (Restaurant/Brasserie, Café/Bar), rayon de recherche 5 km.
const DEFAULT_SELECTED_POI: string[] = ['bus_station', 'tram_station', 'subway_station', 'restaurant', 'cafe'];
const DEFAULT_EXPANDED_GROUPS: string[] = ['Transport', 'Restauration'];
const DEFAULT_SEARCH_RADIUS_KM = 5;

// Minimum delay between two POI searches, to keep Places API usage/cost under control.
const POI_VALIDATE_COOLDOWN_MS = 2 * 60 * 1000;

async function routeGuard(to: Route, from: Route, next: Function) {
    try {
        // Compute breadcrumb
        const { data: programObj } = await getProgramPrescriber(+to.params.id);
        console.log(programObj);
        program = programObj;
        to.meta.breadcrumb[2].title = program.name;
    } catch (error) {
        if (error.response.status == 404) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Programme introuvable.`,
            });

            next({
                name: 'homePrescriber',
            });
            return;
        }
    }
    next();
}

@Component({
    beforeRouteEnter: routeGuard,
    beforeRouteUpdate: routeGuard,
    filters: {
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatAddress: (add: Address) => {
        const streetParts = [add.street, add.street2].filter(Boolean).join(', ');
        return `${streetParts}<br>${add.postal_code} ${add.city}`;
    }
    },
    components: {
        VxBreadcrumb,
        CarouselPrescriber,
        ProgramDocuments,
        ProgramInfosPrescriber,
        ProgramLots,
        ProgramReportModal,
        ProgramLotsCard,
        HonoModal,
        GoogleMap
    },
})
export default class ProgramDetails extends Vue {
    promotorComments = false;
    honoOpen: boolean = false;
    BACKEND_URL = BACKEND_URL;
    program: Program | null = program;
    private _honoHandler: (() => void) | null = null;


     @Prop({ required: true }) readonly programId!: number;
    @Prop({ default: false }) readonly privateMode!: boolean;


    lotsViewMode:  'table' | 'cards' = 'cards';
    lotsTableEverOpened: boolean = false;

    @Watch('lotsViewMode')
    onLotsViewModeChange(val: string) {
        if (val === 'table') this.lotsTableEverOpened = true;
    }


    comments: any = {
        old: program && program.comment ? program.comment : '',
        input: program && program.comment ? program.comment : '',
        loading: false
    }


    // Whether the "modifier les options" (distance + POI) panel is expanded.
    poiControlsOpen: boolean = false;

    currentImageIndex: number = 0;

    // Couleur associée à chaque groupe de POI (doit rester alignée avec GoogleMap.vue)
    poiGroupColors: Record<string, string> = {
        'Transport': '#7c3aed',
        'Écoles': '#ef4444',
        'Restauration': '#f97316',
        'Marché & Courses': '#3b82f6',
        'Sport': '#22c55e',
        'Santé': '#ec4899',
    };

    groupColor(label: string): string {
        return this.poiGroupColors[label] || '#6b7280';
    }

    // Single-line address for the POI summary bar (the formatAddress filter
    // used elsewhere returns two lines joined by <br>, not suited to a bar).
    get programAddressLine(): string {
        if (!this.program || !this.program.address) return '';
        const { street, street2, postal_code, city } = this.program.address;
        const streetParts = [street, street2].filter(Boolean).join(', ');
        const cityParts = [postal_code, city].filter(Boolean).join(' ');
        return [streetParts, cityParts].filter(Boolean).join(', ');
    }


    copyAddressToClipboard() {
    const address = this.programAddressLine;
    if (address) {
        navigator.clipboard.writeText(address);
        // @ts-ignore
        this.$vs.notify({
            color: 'success',
            title: 'Adresse copiée !',
            text: 'L’adresse a bien été copiée dans le presse-papier.',
        });
    }
}


       // New Function For the Report GEneration ****************
                        
                        reportModalActive: boolean = false;

                        openReportModal() {
                            this.reportModalActive = true;
                        }

                     handleReportGeneration(reportConfig: any) {
                            console.log('Generating PDF with config:', reportConfig);
                            
                            // @ts-ignore
                            this.$vs.notify({
                                color: 'success',
                                title: 'Génération en cours',
                                text: 'Le rapport PDF est en cours de génération...'
                            });
                            
                            this.reportModalActive = false;
                        }






    // Pour L'affichage
    groupVisible: Record<string, boolean> = {};

    created() {
    // When the component is created, mark all groups as visible
    this.poiGroups.forEach(g => {
      this.$set(this.groupVisible, g.label, true);
    });
  }


    searchRadiusKm: number = DEFAULT_SEARCH_RADIUS_KM;

        // -------- Poi Options Part  ---------------------

         poiGroups = [
            {
                label: 'Transport',
                faIcon: 'fa-bus',
                children: [
                { value: 'bus_station',    text: 'Bus' },
                { value: 'tram_station',   text: 'Tramway' },
                { value: 'subway_station', text: 'Métro' },
                { value: 'train_station',  text: 'Gare' },
                { value: 'airport',        text: 'Aéroport' },
                ],
            },
            {
                label: 'Écoles',
                faIcon: 'fa-graduation-cap',
                children: [
                { value: 'primary_school', text: 'École primaire' },
                { value: 'secondary_school', text: 'Collège / Lycée' },
                { value: 'university',     text: 'École supérieure' },
                ],
            },
            {
                label: 'Restauration',
                faIcon: 'fa-utensils',
                children: [
                { value: 'restaurant', text: 'Restaurant / Brasserie' },
                { value: 'cafe',       text: 'Café / Bar' },
                ],
            },
            {
                label: 'Marché & Courses',
                faIcon: 'fa-shopping-basket',
                children: [
                { value: 'grocery_or_supermarket', text: 'Marché / Supermarché' },
                ],
            },
            {
                label: 'Sport',
                faIcon: 'fa-dumbbell',
                children: [
                { value: 'gym',     text: 'Salle de sport' },
                { value: 'stadium', text: 'Complex Sportif' },
                ],
            },
            {
                label: 'Santé',
                faIcon: 'fa-heartbeat',
                children: [
                { value: 'hospital',  text: 'Hôpital' },
                { value: 'pharmacy',  text: 'Pharmacie' },
                { value: 'doctor',    text: 'Médecin' },
                { value: 'dentist',   text: 'Dentiste' },
                { value: 'clinic',    text: 'Clinique' },
                ],
            },
            ];



            // Draft selection: freely edited by the user in the picker, has no
            // effect on the map/API until "Valider les modifications" is clicked.
            selectedPOI: string[] = [...DEFAULT_SELECTED_POI];

            expandedGroups: string[] = [...DEFAULT_EXPANDED_GROUPS];

            // Applied selection: what the map/results panel actually reflect —
            // only updated by validatePOIChanges(), which is what triggers new
            // Places API calls (via the GoogleMap :key remount below).
            appliedPOI: string[] = [...DEFAULT_SELECTED_POI];
            appliedRadiusKm: number = DEFAULT_SEARCH_RADIUS_KM;
            mapRefreshKey: number = 0;

            // Rate-limits how often a new search can be triggered.
            lastPoiValidateAt: number = 0;
            poiCooldownTick: number = 0;
            poiCooldownTimer: any = null;

            poiResults: Record<string, { name: string; distanceKm: string }[]> = {};


            get selectedGroups() {
                    return this.poiGroups.filter(group =>
                    group.children.some(opt => this.selectedPOI.includes(opt.value))
                    );
                }

                /**
                 * For a given group object, return just the children the user selected.
                 */
                selectedInGroup(group: { label: string; children: {value:string; text:string}[] }) {
                    return group.children.filter(opt =>
                    this.selectedPOI.includes(opt.value)
                    );
                }

                // Same as above but for the *applied* selection — used by the summary
                // bar, the map and the results panel, so they only ever show what was
                // actually fetched.
                get appliedGroups() {
                    return this.poiGroups.filter(group =>
                    group.children.some(opt => this.appliedPOI.includes(opt.value))
                    );
                }

                appliedInGroup(group: { label: string; children: {value:string; text:string}[] }) {
                    return group.children.filter(opt =>
                    this.appliedPOI.includes(opt.value)
                    );
                }

                get hasPendingPOIChanges(): boolean {
                    if (this.searchRadiusKm !== this.appliedRadiusKm) return true;
                    if (this.selectedPOI.length !== this.appliedPOI.length) return true;
                    const applied = new Set(this.appliedPOI);
                    return this.selectedPOI.some(v => !applied.has(v));
                }

                // Milliseconds left before another search is allowed (0 = ready now).
                get poiValidateCooldownMs(): number {
                    // Reading poiCooldownTick keeps this getter reactive while the timer ticks.
                    void this.poiCooldownTick;
                    if (!this.lastPoiValidateAt) return 0;
                    return Math.max(0, POI_VALIDATE_COOLDOWN_MS - (Date.now() - this.lastPoiValidateAt));
                }

                get poiValidateCooldownLabel(): string {
                    const totalSeconds = Math.ceil(this.poiValidateCooldownMs / 1000);
                    const minutes = Math.floor(totalSeconds / 60);
                    const seconds = totalSeconds % 60;
                    return minutes > 0 ? `${minutes}:${seconds.toString().padStart(2, '0')}` : `${seconds}s`;
                }




                        // Toggle a group open/closed
            toggleGroup(label: string) {
                const i = this.expandedGroups.indexOf(label);
                if (i === -1) {
                this.expandedGroups.push(label);
                } else {
                this.expandedGroups.splice(i, 1);
                }
            }



            get firstname() {
                    return AuthModule.firstname;
                }

                get lastname() {
                    return AuthModule.lastname;
                }

                get logo() {
                    return AuthModule.logo;
                }

                get isSubscribed() {
                    return AuthModule.isSubscriptionActive;
                }


                get isPrivateMode() {
                    return FiltersModule.privateMode;
                }






  // les Filters et Affichage de Div

            /**
             * Applies the draft POI selection/radius: snapshots them into
             * appliedPOI/appliedRadiusKm and bumps mapRefreshKey, which remounts
             * <GoogleMap> and triggers fresh Places API calls. Rate-limited so a
             * user can't spam new searches (and rack up Places API costs).
             */
            validatePOIChanges() {
                if (!this.hasPendingPOIChanges) return;

                if (this.poiValidateCooldownMs > 0) {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'warning',
                        title: 'Un instant…',
                        text: `Désolé, merci de patienter encore ${this.poiValidateCooldownLabel} avant de relancer une recherche.`,
                        position: 'top-right',
                    });
                    return;
                }

                this.appliedPOI = [...this.selectedPOI];
                this.appliedRadiusKm = this.searchRadiusKm;
                this.poiResults = {};
                this.poiGroups.forEach(g => {
                    this.$set(this.groupVisible, g.label, true);
                });

                this.lastPoiValidateAt = Date.now();
                this.mapRefreshKey++;
                this.startPoiCooldownTimer();
            }

            startPoiCooldownTimer() {
                if (this.poiCooldownTimer) return;
                this.poiCooldownTimer = setInterval(() => {
                    this.poiCooldownTick++;
                    if (this.poiValidateCooldownMs <= 0 && this.poiCooldownTimer) {
                        clearInterval(this.poiCooldownTimer);
                        this.poiCooldownTimer = null;
                    }
                }, 1000);
            }



    @Watch('comments.loading')
    onLoading() {
        if (this.comments.loading) {
            // @ts-ignore
            this.$vs.loading({
                color: 'primary',
                type: 'corners',
            });
        } else {
            // @ts-ignore
            this.$vs.loading.close();
        }
    }



             mounted() {
                const userPrimaryColor = this.getUserPrimaryColor();
                if (userPrimaryColor) {
                    this.setPrimaryColor(userPrimaryColor);
                }

                this._honoHandler = () => { this.honoOpen = true; };
                this.$root.$on('open-hono-modal', this._honoHandler);

                this.loadProgram();
            }

            beforeDestroy() {
                if (this._honoHandler) {
                    this.$root.$off('open-hono-modal', this._honoHandler);
                }
                const carousel = this.$refs.heroCarousel as any;
                if (carousel) {
                    carousel.$off('pageChange');
                }
                if (this.poiCooldownTimer) {
                    clearInterval(this.poiCooldownTimer);
                    this.poiCooldownTimer = null;
                }
            }
            
            @Watch('isPrivateMode')
                onPrivateModeChange(newValue: boolean) {
                    this.loadProgram();
                }
            
           
            
            async loadProgram() {
                try {
                    const { data: programObj } = await getProgramPrescriber(this.programId);
                    this.program = programObj;

                    this.$nextTick(() => {
                        const carousel = this.$refs.heroCarousel as any;
                        if (carousel) {
                            carousel.$off('pageChange');
                            carousel.$on('pageChange', (page: number) => {
                                this.currentImageIndex = page;
                            });
                        }
                    });

                    this.filterBrokenImages();
                } catch (error) {
                    console.error('Failed to load program:', error);
                }
            }

            async filterBrokenImages() {
                if (!this.program || !this.program.images || !this.program.id) return;

                const checkUrl = (url: string): Promise<boolean> =>
                    new Promise(resolve => {
                        const img = new Image();
                        img.onload = () => resolve(true);
                        img.onerror = () => resolve(false);
                        img.src = url;
                    });

                const items = this.program.images
                    .filter(x => x && x.id && x.image)
                    .map(x => ({
                        id: x.id as number,
                        url: `${IMAGES_BASE_URL}${x.image.url}${x.image.name}.${x.image.extension}`,
                        extension: String(x.image.extension || '').toLowerCase(),
                    }));

                const results = await Promise.all(
                    items.map(async item => ({ id: item.id, extension: item.extension, valid: await checkUrl(item.url) }))
                );

                const broken = results.filter(r => !r.valid);
                if (broken.length === 0) return;

                const brokenIds = new Set(broken.map(r => r.id));
                const programId = this.program.id;

                // Priorité de nettoyage : on supprime d'abord les images legacy
                // (jpg/png/gif...), et seulement ensuite les webp, pour protéger
                // au maximum les images déjà migrées en WebP.
                const legacyIds = broken.filter(r => r.extension !== 'webp').map(r => r.id);
                const webpIds = broken.filter(r => r.extension === 'webp').map(r => r.id);

                await Promise.all(
                    legacyIds.map(id => deleteImageProgramPrescriber(programId, id).catch(() => {}))
                );
                await Promise.all(
                    webpIds.map(id => deleteImageProgramPrescriber(programId, id).catch(() => {}))
                );

                this.$set(
                    this.program,
                    'images',
                    this.program.images.filter((x: any) => !brokenIds.has(x.id))
                );
            }




    async saveComments() {
        let error = false;
        if(!this.program ||!this.program.id) {
            return;
        }
        this.comments.old = this.comments.input;
        this.comments.loading = true;
        const $vs = (this as any).$vs;
        try {
            const {data} = await postCommentProgram(this.comments, this.program.id);
        } catch (error) {
            error = true;
        }
        this.comments.loading = false;
        if(error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de l\'enregistrement de votre commentaire',
            });
        } else {
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Commentaire enregistré',
                text: 'Vous pourrez retrouver ce programme grace au filtre dans la carte des programmes',
            });
        }
    }

    get promotorStars() {
        if (!this.program || !this.program.promoter) {
            return [];
        }

        if(this.program.promoter.nb_of_stars){
            let nbOfStars = [];
            let counter = 0;
            while (counter < this.program.promoter.nb_of_stars) {
                counter++;
                nbOfStars.push(counter);
            }
            return nbOfStars;
        }
    }

    get promotorStarsNegative() {
        if (!this.program || !this.program.promoter) {
            return [];
        }

        if(this.program.promoter.nb_of_stars){
            let nbOfStarsNegative = [];
            let counter = 0;
            while (counter < (5 - this.program.promoter.nb_of_stars)) {
                counter++;
                nbOfStarsNegative.push(counter);
            }
            return nbOfStarsNegative;
        }
    }

    get images() {
        if (!this.program || !this.program.images) {
            return [];
        }

        const __images = this.program.images.map(x => x.image);
        const _images = concat(this.program.primary_perspective, __images);
        const images = compact(_images);

        return images.map(
            image =>
               `${IMAGES_BASE_URL}${image.url}${image.name}.${image.extension}`
        );
    }


            
    setPrimaryColor(hexColor: string): void {
                const r: number = parseInt(hexColor.slice(1, 3), 16);
                const g: number = parseInt(hexColor.slice(3, 5), 16);
                const b: number = parseInt(hexColor.slice(5, 7), 16);
                
                document.documentElement.style.setProperty('--primary-color', hexColor);
        
                document.documentElement.style.setProperty('--vs-primary', `${r}, ${g}, ${b}`);
                document.documentElement.style.setProperty('--vs-personal_color', `${r}, ${g}, ${b}`);
            }

            getUserPrimaryColor(): string {
                const authJson = localStorage.getItem('auth')
                if (authJson) {
                    try {
                    const auth = JSON.parse(authJson)
                    return auth.personal_color || '#ff5733'
                    } catch {
                    return '#ff5733'
                    }
                }
                return '#ff5733'
                }

            initializeUserColor(): void {
                const personalColor = this.getUserPrimaryColor();
                this.setPrimaryColor(personalColor);
            }


                galleryPopupActive: boolean = false;
                selectedImageIndex: number = 0;

                
                

                previousImage(): void {
                    const carousel = this.$refs.heroCarousel as any;
                    if (carousel && carousel.page > 0) {
                    carousel.page--;
                    this.currentImageIndex = carousel.page;
                    } else if (carousel && this.images.length > 0) {
                    carousel.page = this.images.length - 1;
                    this.currentImageIndex = this.images.length - 1;
                    }
                }

                nextImage(): void {
                    const carousel = this.$refs.heroCarousel as any;
                    if (carousel && carousel.page < this.images.length - 1) {
                    carousel.page++;
                    this.currentImageIndex = carousel.page;
                    } else if (carousel && this.images.length > 0) {
                    carousel.page = 0;
                    this.currentImageIndex = 0;
                    }
                }

                openGallery(): void {
                    // Get current index from carousel
                    const carousel = this.$refs.heroCarousel as any;
                    this.selectedImageIndex = carousel ? carousel.page : 0;
                    this.galleryPopupActive = true;
                }

                previousGalleryImage(): void {
                    if (this.selectedImageIndex > 0) {
                    this.selectedImageIndex--;
                    } else {
                    this.selectedImageIndex = this.images.length - 1;
                    }
                }

                nextGalleryImage(): void {
                    if (this.selectedImageIndex < this.images.length - 1) {
                    this.selectedImageIndex++;
                    } else {
                    this.selectedImageIndex = 0;
                    }
                }
             




                  addBr(value: string): string {
                        if (!value) return '';
                        
                        // Check if content already has HTML tags - if yes, return as-is
                        if (/<[a-z][\s\S]*>/i.test(value)) {
                            return value;
                        }
                        
                        // Otherwise, apply your existing formatting logic
                        const normalized = value.replace(/\r\n/g, '\n');
                        const paras = normalized
                            .split(/\n{2,}/)
                            .map(p => p.trim())
                            .filter(p => p);

                        return paras
                            .map(p => {
                            const withLineBreaks = p.replace(/\n/g, '<br><br>');
                            return withLineBreaks.replace(
                                /\. (?=[A-ZÀ-ÖÙ-Ý])/g,
                                '.<br> '
                            );
                            })
                            .map(p => `<p>${p}</p>`)
                            .join('');
                        }



                        

                        /**
                         * Exact-break mode + sentence breaks
                         *  • Every \n ⇒ <br><br>
                         *  • Every “. ” followed by uppercase ⇒ “.<br> ”
                         */
                         addBrExact(value: string): string {
                        if (!value) return '';

                        return value
                            .replace(/\r\n/g, '\n')
                            .replace(/\n/g, '<br><br>')
                            .replace(/\. (?=[A-ZÀ-ÖÙ-Ý])/g, '.<br> ');
                        }




                        formatDocsComment(value: string): string {
                            if (!value) return '';
                            
                            // 1) Normaliser les retours à la ligne
                            let formatted = value.replace(/\r\n/g, '\n');
                            
                            // 2) Traiter les titres principaux (1#) avec couleur optionnelle
                            // Pattern: 1#color Title # ou 1# Title #
                            formatted = formatted.replace(
                                /1#(?:(red|blue|green|orange|purple|yellow)\s+)?([^#]+)#/gi,
                                (match, color, title) => {
                                    const trimmedTitle = title.trim();
                                    const colorStyle = color ? `color: ${color.toLowerCase()};` : 'color: #2c3e50;';
                                    return `<div class="doc-title-main" style="${colorStyle}">
                                        <i class="fas fa-star"></i>
                                        <h1 style="display: inline-block; margin: 0 10px; font-size: 24px; font-weight: bold; ${colorStyle}">${trimmedTitle}</h1>
                                        <i class="fas fa-star"></i>
                                    </div>`;
                                }
                            );
                            
                            // 3) Traiter les sous-titres (2#) avec couleur optionnelle
                            // Pattern: 2#color Title # ou 2# Title #
                            formatted = formatted.replace(
                                /2#(?:(red|blue|green|orange|purple|yellow)\s+)?([^#]+)#/gi,
                                (match, color, title) => {
                                    const trimmedTitle = title.trim();
                                    const colorStyle = color ? `color: ${color.toLowerCase()};` : 'color: #34495e;';
                                    return `<div class="doc-title-secondary" style="margin: 15px 0 10px 0;">
                                        <i class="fas fa-chevron-right" style="${colorStyle}"></i>
                                        <h2 style="display: inline-block; margin: 0 8px; font-size: 18px; font-weight: bold; ${colorStyle}">${trimmedTitle}</h2>
                                    </div>`;
                                }
                            );
                            
                            // 4) Traiter les textes colorés simples (#color text #)
                            formatted = formatted.replace(
                                /#(red|blue|green|orange|purple|yellow)\s+([^#]+)#/gi,
                                (match, color, text) => {
                                    const trimmedText = text.trim();
                                    const bgColor = this.getBackgroundColor(color.toLowerCase());
                                    return `<span style="color: ${color.toLowerCase()}; background-color: ${bgColor}; padding: 2px 6px; border-radius: 3px; font-weight: 600;">${trimmedText}</span>`;
                                }
                            );
                            
                            // 5) Traiter les paragraphes et sauts de ligne
                            const paras = formatted
                                .split(/\n{2,}/)
                                .map(p => p.trim())
                                .filter(p => p);
                            
                            return paras
                                .map(p => {
                                    // Si c'est déjà un titre formaté, ne pas le wrapper dans <p>
                                    if (p.includes('doc-title-main') || p.includes('doc-title-secondary')) {
                                        return p;
                                    }
                                    // Remplacer les simples retours à la ligne par <br>
                                    const withLineBreaks = p.replace(/\n/g, '<br>');
                                    return `<p style="margin: 10px 0; line-height: 1.6;">${withLineBreaks}</p>`;
                                })
                                .join('');
                        }

                        // Fonction helper pour obtenir une couleur de fond légère
                        getBackgroundColor(color: string): string {
                            const backgrounds: { [key: string]: string } = {
                                'red': '#ffe6e6',
                                'blue': '#e6f2ff',
                                'green': '#e6ffe6',
                                'orange': '#fff0e6',
                                'purple': '#f3e6ff',
                                'yellow': '#ffffcc'
                            };
                            return backgrounds[color] || '#f0f0f0';
                        }



        


                 


}
